import { Link, useLocation } from "react-router-dom";
import { useAuthContext } from "@/components/AuthProvider";
import { CenterSelector } from "@/components/CenterSelector";
import type { ReactNode } from "react";

interface LayoutProps {
  children: ReactNode;
}

const navItems = [
  { path: "/", label: "대시보드" },
  { path: "/centers", label: "센터 관리" },
];

export function Layout({ children }: LayoutProps) {
  const location = useLocation();
  const auth = useAuthContext();
  const user = auth.status === "authenticated" ? auth.user : null;

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <header className="bg-white shadow-sm border-b">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <div className="flex items-center gap-8">
              <Link to="/" className="text-xl font-bold text-gray-900 no-underline">
                VLAB Pilates
              </Link>
              <nav className="flex gap-4">
                {navItems.map((item) => (
                  <Link
                    key={item.path}
                    to={item.path}
                    className={`px-3 py-2 rounded-md text-sm font-medium ${
                      item.path === "/"
                        ? location.pathname === "/"
                          ? "bg-blue-100 text-blue-700"
                          : "text-gray-600 hover:bg-gray-100"
                        : location.pathname.startsWith(item.path)
                          ? "bg-blue-100 text-blue-700"
                          : "text-gray-600 hover:bg-gray-100"
                    }`}
                  >
                    {item.label}
                  </Link>
                ))}
              </nav>
            </div>
            <div className="flex items-center gap-4">
              <CenterSelector />
              {user && <span className="text-sm text-gray-600">{user.name}</span>}
              <button
                onClick={auth.signOut}
                className="px-3 py-2 text-sm text-gray-600 hover:text-gray-900"
              >
                로그아웃
              </button>
            </div>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">{children}</main>
    </div>
  );
}
